export default __webpack_public_path__ + "static/media/onboarding_mc_authority_letter.6d29d28e.png";